export enum MarketBreakdownReportTypeEnum {
  sales = 1,
  registration
}
